export default "__VITE_ASSET__DiD5iVXB__"